import React, { useState } from 'react';
import  "../../../../LeadsSalesView/LeadsSalesProfileManagementView/LeadsProfileManagement.Style.scss" ; 
import Styles from './MatchedNewUnitCard.module.scss';
import  GeneralStyles  from "./MatchedUnitCard.scss" ;
import {
  LoadableImageComponant,
  SelectComponet, 
  CheckboxesComponent 
} from '../../../../../../Components'
import {
  DefaultImagesEnum,
  LoadableImageEnum,
  UnitsOperationTypeEnum,
} from '../../../../../../Enums';
import Button from '@material-ui/core/Button';
import { formatCommasForPriceUnit } from '../../../../../../Helper/formatCommas.Helper';
import { CopyToClipboardComponents } from '../../../../../../ReusableComponents/UtilityComponents';
import {
  getDownloadableLink,
  GetParams,
  showError,
  showSuccess,
  showWarn,
} from '../../../../../../Helper';
import { GetSuitableTemplateIdForUnit  } from '../../../../../../Services' ; 
import { useTranslation } from 'react-i18next';
import bedIcon from '../../../../../../assets/images/Propxicon/side-bed.svg';
import ParkingIcon from '../../../../../../assets/images/Propxicon/parking.svg';
import bathIcon from '../../../../../../assets/images/icons/bath.svg';
import broomIcon from '../../../../../../assets/images/icons/broom.svg';
import areaIcon from '../../../../../../assets/images/icons/area.svg';
import bookmarkCheck from '../../../../../../assets/images/Propxicon/bookmark-check.svg';
import bookmarkIcon from '../../../../../../assets/images/icons/bookmark.svg' ; 
import bookmarkCheckIcon from '../../../../../../assets/images/icons/bookmark-check.svg' ; 
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ProposalStartButton from '../../../../SmartProposal/Utilities/ProposalThemeDialog/ProposalStartButton';
import { UnitTemplateDialogPreviewDialog } from '../../../../UnitsView/UnitsProfileManagementView/Dialogs/UnitTemplateDialog/UnitTemplateDialogPreviewDialog';


export const MatchedNewUnitCard = ({
  data,
  reload,
  parentTranslationPath,
  translationPath,
  actionButtons,
  viewUnitHandler,
  isLease,
   getIsSelectedCard , 
  onCardCheckboxClick,
  index ,
  isSmartProposalActive ,
  activeLead , 
  saleMatching

}) => {
  const { t } = useTranslation([parentTranslationPath]);
  const [templatesProposal, setTemplatesProposal] = useState([]);
  const [activeTemplateId, setActiveTemplateId] = useState(-1);
  const [isLoading, setIsLoading] = useState({
    template: false,
  });
  const [templates, setTemplates] = useState([]);
  const [activeTemplateName, setActiveTemplateName] = useState(null);
  const [isOpenTemplateDialog, setIsOpenTemplateDialog] = useState(false);

      const GetSuitableTemplateIdForUnitApi = async () => {
        setIsLoading((prevState) => ({ ...prevState, template: true }));
        let res;
        res = await GetSuitableTemplateIdForUnit(
          data.unitId,
          1,
          10000,
         (data?.newMatchingUnitIsSale ? UnitsOperationTypeEnum.sale.key :  UnitsOperationTypeEnum.rent.key)
        );
        if (!((res && res.data && res.data.ErrorId) || !res))
          setTemplatesProposal((res && res.result) || []);
        else setTemplatesProposal([]);
        setIsLoading((prevState) => ({ ...prevState, template: false }));
      };
  
  function convertObject1ToObject2(obj1) {
  const unit = obj1?.unit || {};

  const unitJsonObj = {
    unit: {
      selling_price_agency_fee: unit?.selling_price_agency_fee || {
        salePrice: 0,
        agencyFee: 0,
        persantageFee: 0
      },
      unit_type_id: unit?.unit_type_id || null,
      operation_type: unit?.operation_type || null,
      new_unit: "No",
      unit_type: unit?.unit_type || null,
      furnished: "N/A",
      property_name: unit?.property_name || null,
      unit_number: "N/A",
      data_completed: unit?.data_completed || 0,
      sale_type: unit?.sale_type || null,
      unit_ref_no: unit?.unit_ref_no || null,
      status: unit?.status || null,
      unit_usage_type: unit?.unit_usage_type || null,
      owner: unit?.owner || [],
      amount_due_to_developer: unit?.amount_due_to_developer || 0,
      discount: 0,
      transfer_fee_seller: 0,
      transfer_fee_buyer: 0,
      transfer_fee_completed_paid: 0,
      seller_has_paid: 0,
      builtup_area_sqft: unit?.builtup_area_sqft || 0,
      bedrooms: unit?.bedrooms || 0,
      bathrooms: "N/A",
      community: unit?.community || null,
      sub_community: null,
      country: unit?.country || null,
      city: unit?.city || null,
      district: unit?.district || null
    }
  };

  return {
    unitId: obj1?.unitId,
    unitJson: JSON.stringify(unitJsonObj),
    createdOn: obj1?.createdOn,
    updateOn: obj1?.updateOn,
    status: obj1?.status,
    leaseStatus: obj1?.leaseStatus,
    matchUnit: obj1?.matchUnit || null,
    createdBy: obj1?.createdBy,
    updatedBy: obj1?.updatedBy,
    portalsJson: null,
    isPublishUnitSale: obj1?.isPublishUnitSale || null,
    isPublishUnitLease: obj1?.isPublishUnitLease || null,
    statusDate: obj1?.statusDate || null,
    lastSalePublishDate: obj1?.lastSalePublishDate || null,
    lastLeasePublishDate: obj1?.lastLeasePublishDate || null,
    statusCreatedByName: obj1?.statusCreatedByName || null,
    updatedOwnerDate: obj1?.updatedOwnerDate || null,
    isSharedUnit: obj1?.isSharedUnit || null,
    unitImages: obj1?.unitImages || null,
    isBulkUpload: obj1?.isBulkUpload || null,
    totalCount: obj1?.totalCount || 0,
    lastActivityTypeId: obj1?.lastActivityTypeId || 0,
    lastActivtyTypeName: obj1?.lastActivtyTypeName || null,
    lastActivityDate: obj1?.lastActivityDate || null,
    isFavorite: obj1?.isFavorite || false,
    isDealOfTheDay: obj1?.isDealOfTheDay || null,
    dealExpirationPeriod: obj1?.dealExpirationPeriod || null,
    dealStartDate: obj1?.dealStartDate || null,
    marketComparison: obj1?.marketComparison || "",
    favoriteFolderId: obj1?.favoriteFolderId || null,
    masterDeveloper: obj1?.masterDeveloper || null,
    matchType: obj1?.matchType || null,
    listUnitImages: obj1?.listUnitImages || null,
    numberOfParkingSpaces: obj1?.numberOfParkingSpaces || 0,
    propertyUnitDistrict: obj1?.propertyUnitDistrict || null,
    propertyUnitCity: obj1?.propertyUnitCity || null,
    propertyUnitCommunity: obj1?.propertyUnitCommunity || null,
    propertyUnitCountry: obj1?.propertyUnitCountry || null,

    // Flattened fields
    selling_price_agency_fee: unit?.selling_price_agency_fee?.salePrice || 0,
    unit_type_id: unit?.unit_type_id,
    operation_type: unit?.operation_type,
    new_unit: "No",
    unit_type: unit?.unit_type,
    furnished: "N/A",
    property_name: unit?.property_name,
    unit_number: "N/A",
    data_completed: unit?.data_completed,
    sale_type: unit?.sale_type,
    unit_ref_no: unit?.unit_ref_no,
    unit_usage_type: unit?.unit_usage_type,
    owner: unit?.owner?.map(o => o.name),
    amount_due_to_developer: unit?.amount_due_to_developer,
    discount: 0,
    transfer_fee_seller: 0,
    transfer_fee_buyer: 0,
    transfer_fee_completed_paid: 0,
    seller_has_paid: 0,
    builtup_area_sqft: unit?.builtup_area_sqft,
    bedrooms: unit?.bedrooms,
    bathrooms: "N/A",
    community: unit?.community,
    sub_community: null,
    country: unit?.country,
    city: unit?.city,
    district: unit?.district,

    // Additional example properties (can be added if needed)
    publishing_requestor: "N/A",
    publishing_requester: "",
    allunitImages: null,
    portals: null,
    refNo: unit?.unit_ref_no || null,
    id: obj1?.unitId,
    type: "corporate",
    name: `${unit.unit_type?.lookupItemName || 'Unit'} ${unit.property_name?.name || ''} ${unit.unit_number || ''}`.trim(),
    propertyName: unit?.property_name?.name || '',
    updateDate: obj1?.updateOn,
    matchingLeads: [],
    matchingLeadsNumber: 0,
    unitTypeId: unit?.unit_type_id,
    unitType: unit?.unit_type?.lookupItemName || '',
    progress: unit?.data_completed || 0,
    progressWithPercentage: `${unit.data_completed || 0}%`,
    operationType: unit?.operation_type?.lookupItemId,
    unitOperationType: unit?.operation_type?.lookupItemName,
    unitStatus: {
      key: obj1?.status,
      value: unit?.status?.toLowerCase() || "available",
      name: unit?.status || "Available",
      showInSelect: true,
      effectedOperationType: unit?.operation_type?.lookupItemId || null,
      classes: "c-primary",
      category: {
        key: 21426,
        value: "sale-sold"
      },
      display: unit?.status || "Available"
    },
    rent_price_fees: "N/A"
  }
}


  return (
    <>
      <div className={Styles.Card_wrapper} key={data?.unitId}>
        <div className={Styles.Card}>
          {isSmartProposalActive && (
            <span
              className="d-flex-v-center-h-end w-100 px-2"
              title={
                !activeLead?.contact_name?.email_address
                  ? t(
                      `${translationPath}this-lead-havent-email-address-to-send-smart-proposal`
                    )
                  : ""
              }
            >
              <CheckboxesComponent
                idRef={`unitsCheckboxItemRef${index + 1}`}
                singleChecked={getIsSelectedCard(data.unitId)}
                onSelectedCheckboxClicked={(event) => {
                  event.preventDefault();
                  if (!activeLead?.contact_name?.email_address) {
                    showWarn(
                      t(`this-lead-havent-email-address-to-send-smart-proposal`)
                    );
                    return;
                  }
                  onCardCheckboxClick(index, data);
                }}
                title={
                  !activeLead?.contact_name?.email_address
                    ? t(`this-lead-havent-email-address-to-send-smart-proposal`)
                    : ""
                }
              />
            </span>
          )}

          <div className={Styles.Card_Content}>
            <div
              className={`${Styles.Card_section1} d-flex-v-center-h-between p`}
            >
              <div
                className="mt-1"
                onClick={viewUnitHandler}
                style={{ cursor: "pointer" }}
              >
                <LoadableImageComponant
                  classes={Styles.Card_Image}
                  type={LoadableImageEnum.div.key}
                  alt={`unit-image`}
                  src={
                    data?.unitImages?.fileId
                      ? getDownloadableLink(data?.unitImages?.fileId)
                      : DefaultImagesEnum.corporate.defaultImg
                  }
                />
              </div>
              <div className={`mt-1 ${Styles.Card__Main_info}`}>
                <div className="mt-2 flex-wrap d-flex-column  w-100">
                  <h6 className={``}>
                    <span className="fw-bold m-0 fz-16px px-2">
                      {formatCommasForPriceUnit(data?.price || 0)}
                    </span>
                    <span style={{ color: "#475467" }} className={`px-1`}>
                      AED
                    </span>
                  </h6>
                  <span className="flex fa-center flex-wrap">
                    {data?.matchType && data?.matchType === "Exact" ? (
                      <img src={bookmarkCheckIcon} alt="bath-Icon" />
                    ) : (
                      <span
                        className="mdi mdi-lightning-bolt"
                        style={{ color: "#FF8C00" }}
                      ></span>
                    )}
                    <span style={{ "font-size": "12px" }} className="">
                      {data?.matchType || ""}
                    </span>
                  </span>
                </div>

                {data?.unit?.property_name ? (
                  <p
                    className={`fz-14px fw-bold  mt-3 mb-1`}
                    onClick={viewUnitHandler}
                    style={{ cursor: "pointer" }}
                  >
                    {data?.unit?.property_name?.name || "N/A"}
                  </p>
                ) : null}
                <p className={`fw-bold fz-12px`}>{data?.propertyUnitCountry}</p>
                <p
                  className={`${GeneralStyles.Fs14} ${GeneralStyles.Fw500} mb-2 `}
                >
                  {data?.fullAddress || data?.unit?.address || null}
                </p>

                {data?.unit?.unit_ref_no ? (
                  <p
                    className={`${GeneralStyles.Fs14} ${GeneralStyles.Fw500} mt-1 mb-1 fw-bold c-primary`}
                  >
                    <span>
                      <CopyToClipboardComponents
                        data={
                          data?.unit?.unit_ref_no &&
                          data?.unit?.unit_ref_no.replace(" ", "")
                        }
                        childrenData={`#${data.unit?.unit_ref_no.replace(
                          " ",
                          ""
                        )}`}
                      />
                    </span>
                  </p>
                ) : null}
              </div>
            </div>
            <div className={`${Styles.Card_section2} d-flex-v-center mb-2`}>
              {data?.unit?.sale_type &&
              data?.unit?.sale_type?.lookupItemName ? (
                <div className={Styles.Outlined_capsule}>
                  <span>
                    {data?.unit?.sale_type &&
                      data?.unit?.sale_type.lookupItemName}
                  </span>
                </div>
              ) : null}
              <p className="fw-bold">
                {data?.unit?.unit_type?.lookupItemName || ""}
              </p>

              <p className="c-primary fw-bold">
                {data?.unit?.unit_status || data?.unitNewStatus || ""}
              </p>
            </div>
            <div className={Styles.Capsules}>
              <div className={Styles.Solid_capsule}>
                <span>
                  <img src={bedIcon} alt="bed-Icon" />
                </span>
                <span>{data?.unit?.bedrooms || "-"}</span>
              </div>

              <div className={Styles.Solid_capsule}>
                <span>
                  <img src={bathIcon} alt="bath-Icon" />
                </span>
                <span>{data?.unit?.bathrooms || "-"}</span>
              </div>

              <div className={Styles.Solid_capsule}>
                <span>
                  <img src={areaIcon} alt="area-Icon" />
                </span>
                <span>{data?.unit?.builtup_area_sqft || "-"}</span>
              </div>

              <div className={Styles.Solid_capsule}>
                <span className="mdi mdi-car flex d-flex-center">
                  {/* <img src={ParkingIcon} alt="broom-Icon" /> */}
                  <span className="px-2">
                    {data?.numberOfParkingSpaces || "-"}
                  </span>
                </span>
              </div>
            </div>
            <div>
              <p>
                <span className={`${GeneralStyles.Fw500} fw-bold  mr-2`}>
                  {t(`listing-agent`)}
                  {" :"}
                </span>
                <span>{data?.listing_agent || "N/A"}</span>
              </p>
            </div>
          </div>
          <div className={Styles.Card_Buttons}>
            {actionButtons?.sendPropsal &&
            activeLead?.contact_name?.email_address ? (
              <ProposalStartButton
                singleUnit={data && convertObject1ToObject2(data)}
                buttonType="solid"
                isLease={activeLead?.leadClass === "Tenant" ? true : false}
                leadMatching={
                  activeLead
                    ? {
                        leadId: activeLead?.leadId || GetParams("id"),
                        lead: activeLead,
                        contactEmailAddress:
                          activeLead?.contact_name?.email_address,
                        contactPhoneNumber:
                          activeLead?.contact_name?.mobile ||
                          activeLead?.contact_name?.phone,
                        contactWhatsApp:
                          activeLead?.contact_name?.mobile ||
                          activeLead?.contact_name?.phone,
                      }
                    : null
                }
                isLeadMatching
                fromLeadForm
              />
            ) : (
              <div>
                {" "}
                <Button
                  onClick={() => {}}
                  disabled
                  className="btns theme-solid px-3"
                  title={t(
                    `${translationPath}this-lead-havent-email-address-to-send-smart-proposal`
                  )}
                >
                  <span className="mdi mdi-rocket px-1" />
                  <span>{t(`${translationPath}smart-proposal`)}</span>
                </Button>
              </div>
            )}
          </div>
        </div>
        {viewUnitHandler && actionButtons.viewUnit ? (
          <Button className={Styles.Side_popup_btn} onClick={viewUnitHandler}>
            <span className="mdi mdi-folder-open"></span>
          </Button>
        ) : null}

        {isOpenTemplateDialog && (
          <UnitTemplateDialogPreviewDialog
            activeItem={activeTemplateId}
            isOpen={isOpenTemplateDialog}
            unitID={data?.unitId}
            unitData={data}
            maintitleText={activeTemplateName}
            unitOwner={data?.leadOwnerDetails}
            leaseUnitOwner={data?.leaseLeadOwnerDetails}
            isOpenChanged={() => {
              setIsOpenTemplateDialog(false);
              setActiveTemplateId(-1);
            }}
            templateName={activeTemplateName}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isLease={!data.newMatchingUnitIsSale}
          />
        )}
      </div>
    </>
  );
};
